import { ibgeService } from './ibge-service';
import { getB2BCitiesList } from './b2b-strategy-data';

export interface MasterCity {
  nome: string;
  uf: string;
  populacao: number;
  regiao: 'Sudeste' | 'Sul' | 'Nordeste' | 'Centro-Oeste' | 'Norte';
  isCapital: boolean;
  lat: number;
  lng: number;
}

export interface TerritoryPreset {
  id: string;
  nome: string;
  descricao: string;
  icone: string;
  badge: string;
  category?: 'estrategico_b2b' | 'censo_nacional' | 'regional';
  cityFilter?: (city: MasterCity) => boolean;
  cityList?: MasterCity[];
}

// Catálogo com as 326 principais cidades do Brasil (Consolidado de lista cidades.md)
export const MASTER_BRAZIL_CITIES: MasterCity[] = [
  // ==================== SUDESTE - SÃO PAULO ====================
  { nome: 'São Paulo', uf: 'SP', populacao: 11451245, regiao: 'Sudeste', isCapital: true, lat: -23.5505, lng: -46.6333 },
  { nome: 'Guarulhos', uf: 'SP', populacao: 1291771, regiao: 'Sudeste', isCapital: false, lat: -23.4542, lng: -46.5333 },
  { nome: 'Campinas', uf: 'SP', populacao: 1139047, regiao: 'Sudeste', isCapital: false, lat: -22.9056, lng: -47.0608 },
  { nome: 'São Bernardo do Campo', uf: 'SP', populacao: 810729, regiao: 'Sudeste', isCapital: false, lat: -23.6914, lng: -46.5647 },
  { nome: 'Santo André', uf: 'SP', populacao: 748919, regiao: 'Sudeste', isCapital: false, lat: -23.6639, lng: -46.5383 },
  { nome: 'Osasco', uf: 'SP', populacao: 743432, regiao: 'Sudeste', isCapital: false, lat: -23.5325, lng: -46.7917 },
  { nome: 'Sorocaba', uf: 'SP', populacao: 723574, regiao: 'Sudeste', isCapital: false, lat: -23.5017, lng: -47.4581 },
  { nome: 'Ribeirão Preto', uf: 'SP', populacao: 698259, regiao: 'Sudeste', isCapital: false, lat: -21.1775, lng: -47.8103 },
  { nome: 'São José dos Campos', uf: 'SP', populacao: 697428, regiao: 'Sudeste', isCapital: false, lat: -23.1896, lng: -45.8841 },
  { nome: 'São José do Rio Preto', uf: 'SP', populacao: 480439, regiao: 'Sudeste', isCapital: false, lat: -20.8114, lng: -49.3758 },
  { nome: 'Mogi das Cruzes', uf: 'SP', populacao: 449779, regiao: 'Sudeste', isCapital: false, lat: -23.5242, lng: -46.1883 },
  { nome: 'Jundiaí', uf: 'SP', populacao: 443116, regiao: 'Sudeste', isCapital: false, lat: -23.1864, lng: -46.8842 },
  { nome: 'Piracicaba', uf: 'SP', populacao: 423323, regiao: 'Sudeste', isCapital: false, lat: -22.7253, lng: -47.6492 },
  { nome: 'Santos', uf: 'SP', populacao: 418608, regiao: 'Sudeste', isCapital: false, lat: -23.9608, lng: -46.3339 },
  { nome: 'Mauá', uf: 'SP', populacao: 418261, regiao: 'Sudeste', isCapital: false, lat: -23.6678, lng: -46.4614 },
  { nome: 'Carapicuíba', uf: 'SP', populacao: 387126, regiao: 'Sudeste', isCapital: false, lat: -23.5222, lng: -46.8356 },
  { nome: 'Bauru', uf: 'SP', populacao: 379146, regiao: 'Sudeste', isCapital: false, lat: -22.3147, lng: -49.0606 },
  { nome: 'Franca', uf: 'SP', populacao: 352279, regiao: 'Sudeste', isCapital: false, lat: -20.5386, lng: -47.4008 },
  { nome: 'Praia Grande', uf: 'SP', populacao: 349935, regiao: 'Sudeste', isCapital: false, lat: -24.0058, lng: -46.4028 },
  { nome: 'São Vicente', uf: 'SP', populacao: 329844, regiao: 'Sudeste', isCapital: false, lat: -23.9631, lng: -46.3919 },
  { nome: 'Barueri', uf: 'SP', populacao: 316473, regiao: 'Sudeste', isCapital: false, lat: -23.5111, lng: -46.8764 },
  { nome: 'Taubaté', uf: 'SP', populacao: 310739, regiao: 'Sudeste', isCapital: false, lat: -23.0264, lng: -45.5553 },
  { nome: 'Suzano', uf: 'SP', populacao: 307364, regiao: 'Sudeste', isCapital: false, lat: -23.5425, lng: -46.3108 },
  { nome: 'Limeira', uf: 'SP', populacao: 291869, regiao: 'Sudeste', isCapital: false, lat: -22.5647, lng: -47.4017 },
  { nome: 'Sumaré', uf: 'SP', populacao: 279546, regiao: 'Sudeste', isCapital: false, lat: -22.8219, lng: -47.2669 },
  { nome: 'Cotia', uf: 'SP', populacao: 273640, regiao: 'Sudeste', isCapital: false, lat: -23.6039, lng: -46.9189 },
  { nome: 'Taboão da Serra', uf: 'SP', populacao: 273542, regiao: 'Sudeste', isCapital: false, lat: -23.6261, lng: -46.7589 },
  { nome: 'Indaiatuba', uf: 'SP', populacao: 255748, regiao: 'Sudeste', isCapital: false, lat: -23.0903, lng: -47.2181 },
  { nome: 'São Carlos', uf: 'SP', populacao: 254857, regiao: 'Sudeste', isCapital: false, lat: -22.0175, lng: -47.8908 },
  { nome: 'Jacareí', uf: 'SP', populacao: 240275, regiao: 'Sudeste', isCapital: false, lat: -23.3056, lng: -45.9658 },
  { nome: 'Marília', uf: 'SP', populacao: 237629, regiao: 'Sudeste', isCapital: false, lat: -22.2139, lng: -49.9458 },
  { nome: 'Americana', uf: 'SP', populacao: 237247, regiao: 'Sudeste', isCapital: false, lat: -22.7394, lng: -47.3314 },
  { nome: 'Hortolândia', uf: 'SP', populacao: 236602, regiao: 'Sudeste', isCapital: false, lat: -22.8583, lng: -47.2200 },
  { nome: 'Itapevi', uf: 'SP', populacao: 232513, regiao: 'Sudeste', isCapital: false, lat: -23.5489, lng: -46.9342 },
  { nome: 'Araraquara', uf: 'SP', populacao: 242228, regiao: 'Sudeste', isCapital: false, lat: -21.7947, lng: -48.1767 },
  { nome: 'Presidente Prudente', uf: 'SP', populacao: 225668, regiao: 'Sudeste', isCapital: false, lat: -22.1256, lng: -51.3889 },
  { nome: 'Rio Claro', uf: 'SP', populacao: 201418, regiao: 'Sudeste', isCapital: false, lat: -22.4114, lng: -47.5614 },
  { nome: 'Bragança Paulista', uf: 'SP', populacao: 176811, regiao: 'Sudeste', isCapital: false, lat: -22.9528, lng: -46.5419 },
  { nome: 'Itu', uf: 'SP', populacao: 168243, regiao: 'Sudeste', isCapital: false, lat: -23.2642, lng: -47.2992 },
  { nome: 'São Caetano do Sul', uf: 'SP', populacao: 165655, regiao: 'Sudeste', isCapital: false, lat: -23.6228, lng: -46.5550 },
  { nome: 'Pindamonhangaba', uf: 'SP', populacao: 165428, regiao: 'Sudeste', isCapital: false, lat: -22.9247, lng: -45.4614 },
  { nome: 'Santana de Parnaíba', uf: 'SP', populacao: 154105, regiao: 'Sudeste', isCapital: false, lat: -23.4442, lng: -46.9178 },
  { nome: 'Botucatu', uf: 'SP', populacao: 145154, regiao: 'Sudeste', isCapital: false, lat: -22.8858, lng: -48.4450 },
  { nome: 'Franco da Rocha', uf: 'SP', populacao: 144849, regiao: 'Sudeste', isCapital: false, lat: -23.3283, lng: -46.7269 },
  { nome: 'Atibaia', uf: 'SP', populacao: 143911, regiao: 'Sudeste', isCapital: false, lat: -23.1178, lng: -46.5564 },
  { nome: 'Caraguatatuba', uf: 'SP', populacao: 134811, regiao: 'Sudeste', isCapital: false, lat: -23.6228, lng: -45.4125 },
  { nome: 'Salto', uf: 'SP', populacao: 134319, regiao: 'Sudeste', isCapital: false, lat: -23.2008, lng: -47.2872 },
  { nome: 'Jaú', uf: 'SP', populacao: 133421, regiao: 'Sudeste', isCapital: false, lat: -22.2964, lng: -48.5586 },
  { nome: 'Araras', uf: 'SP', populacao: 130866, regiao: 'Sudeste', isCapital: false, lat: -22.3572, lng: -47.3842 },
  { nome: 'Sertãozinho', uf: 'SP', populacao: 126811, regiao: 'Sudeste', isCapital: false, lat: -21.1378, lng: -47.9897 },
  { nome: 'Valinhos', uf: 'SP', populacao: 126373, regiao: 'Sudeste', isCapital: false, lat: -22.9708, lng: -46.9958 },
  { nome: 'Itatiba', uf: 'SP', populacao: 122581, regiao: 'Sudeste', isCapital: false, lat: -23.0058, lng: -46.8406 },
  { nome: 'Barretos', uf: 'SP', populacao: 122485, regiao: 'Sudeste', isCapital: false, lat: -20.5572, lng: -48.5678 },
  { nome: 'Guaratinguetá', uf: 'SP', populacao: 118044, regiao: 'Sudeste', isCapital: false, lat: -22.8164, lng: -45.1925 },
  { nome: 'Jandira', uf: 'SP', populacao: 118045, regiao: 'Sudeste', isCapital: false, lat: -23.5278, lng: -46.9028 },
  { nome: 'Catanduva', uf: 'SP', populacao: 115785, regiao: 'Sudeste', isCapital: false, lat: -21.1383, lng: -48.9731 },
  { nome: 'Várzea Paulista', uf: 'SP', populacao: 115771, regiao: 'Sudeste', isCapital: false, lat: -23.2128, lng: -46.8286 },
  { nome: 'Ribeirão Pires', uf: 'SP', populacao: 115559, regiao: 'Sudeste', isCapital: false, lat: -23.7142, lng: -46.4136 },
  { nome: 'Cubatão', uf: 'SP', populacao: 112471, regiao: 'Sudeste', isCapital: false, lat: -23.8950, lng: -46.4253 },
  { nome: 'Paulínia', uf: 'SP', populacao: 110537, regiao: 'Sudeste', isCapital: false, lat: -22.7611, lng: -47.1539 },
  { nome: 'Itanhaém', uf: 'SP', populacao: 108000, regiao: 'Sudeste', isCapital: false, lat: -24.1831, lng: -46.7892 },
  { nome: 'Ourinhos', uf: 'SP', populacao: 103970, regiao: 'Sudeste', isCapital: false, lat: -22.9789, lng: -49.8706 },
  { nome: 'Assis', uf: 'SP', populacao: 101409, regiao: 'Sudeste', isCapital: false, lat: -22.6625, lng: -50.4181 },
  { nome: 'Mogi Mirim', uf: 'SP', populacao: 92559, regiao: 'Sudeste', isCapital: false, lat: -22.4319, lng: -46.9578 },
  { nome: 'São João da Boa Vista', uf: 'SP', populacao: 92503, regiao: 'Sudeste', isCapital: false, lat: -21.9689, lng: -46.7978 },
  { nome: 'Arujá', uf: 'SP', populacao: 92441, regiao: 'Sudeste', isCapital: false, lat: -23.3964, lng: -46.3208 },
  { nome: 'Avaré', uf: 'SP', populacao: 92124, regiao: 'Sudeste', isCapital: false, lat: -23.0989, lng: -48.9256 },
  { nome: 'Lins', uf: 'SP', populacao: 78910, regiao: 'Sudeste', isCapital: false, lat: -21.6789, lng: -49.7508 },
  { nome: 'Itapira', uf: 'SP', populacao: 75234, regiao: 'Sudeste', isCapital: false, lat: -22.4339, lng: -46.8228 },
  { nome: 'Amparo', uf: 'SP', populacao: 73120, regiao: 'Sudeste', isCapital: false, lat: -22.7039, lng: -46.7644 },

  // ==================== SUDESTE - MINAS GERAIS ====================
  { nome: 'Belo Horizonte', uf: 'MG', populacao: 2315560, regiao: 'Sudeste', isCapital: true, lat: -19.9167, lng: -43.9345 },
  { nome: 'Uberlândia', uf: 'MG', populacao: 713232, regiao: 'Sudeste', isCapital: false, lat: -18.9186, lng: -48.2772 },
  { nome: 'Contagem', uf: 'MG', populacao: 621865, regiao: 'Sudeste', isCapital: false, lat: -19.9318, lng: -44.0536 },
  { nome: 'Juiz de Fora', uf: 'MG', populacao: 540756, regiao: 'Sudeste', isCapital: false, lat: -21.7642, lng: -43.3503 },
  { nome: 'Betim', uf: 'MG', populacao: 411784, regiao: 'Sudeste', isCapital: false, lat: -19.9676, lng: -44.2001 },
  { nome: 'Montes Claros', uf: 'MG', populacao: 414240, regiao: 'Sudeste', isCapital: false, lat: -16.7282, lng: -43.8578 },
  { nome: 'Uberaba', uf: 'MG', populacao: 337846, regiao: 'Sudeste', isCapital: false, lat: -19.7483, lng: -47.9319 },
  { nome: 'Ribeirão das Neves', uf: 'MG', populacao: 329794, regiao: 'Sudeste', isCapital: false, lat: -19.7669, lng: -44.0867 },
  { nome: 'Governador Valadares', uf: 'MG', populacao: 257172, regiao: 'Sudeste', isCapital: false, lat: -18.8511, lng: -41.9494 },
  { nome: 'Ipatinga', uf: 'MG', populacao: 227731, regiao: 'Sudeste', isCapital: false, lat: -19.4686, lng: -42.5369 },
  { nome: 'Sete Lagoas', uf: 'MG', populacao: 227360, regiao: 'Sudeste', isCapital: false, lat: -19.4658, lng: -44.2467 },
  { nome: 'Divinópolis', uf: 'MG', populacao: 231091, regiao: 'Sudeste', isCapital: false, lat: -20.1428, lng: -44.8872 },
  { nome: 'Santa Luzia', uf: 'MG', populacao: 219132, regiao: 'Sudeste', isCapital: false, lat: -19.7697, lng: -43.8514 },
  { nome: 'Ibirité', uf: 'MG', populacao: 170537, regiao: 'Sudeste', isCapital: false, lat: -20.0219, lng: -44.0589 },
  { nome: 'Poços de Caldas', uf: 'MG', populacao: 163742, regiao: 'Sudeste', isCapital: false, lat: -21.7853, lng: -46.5653 },
  { nome: 'Patos de Minas', uf: 'MG', populacao: 159214, regiao: 'Sudeste', isCapital: false, lat: -18.5789, lng: -46.5181 },
  { nome: 'Teófilo Otoni', uf: 'MG', populacao: 158742, regiao: 'Sudeste', isCapital: false, lat: -17.8575, lng: -41.5053 },
  { nome: 'Pouso Alegre', uf: 'MG', populacao: 152212, regiao: 'Sudeste', isCapital: false, lat: -22.2300, lng: -45.9364 },
  { nome: 'Varginha', uf: 'MG', populacao: 136467, regiao: 'Sudeste', isCapital: false, lat: -21.5514, lng: -45.4328 },
  { nome: 'Conselheiro Lafaiete', uf: 'MG', populacao: 131621, regiao: 'Sudeste', isCapital: false, lat: -20.6603, lng: -43.7864 },
  { nome: 'Sabará', uf: 'MG', populacao: 129428, regiao: 'Sudeste', isCapital: false, lat: -19.8914, lng: -43.8064 },
  { nome: 'Araguari', uf: 'MG', populacao: 117825, regiao: 'Sudeste', isCapital: false, lat: -18.6486, lng: -48.1928 },
  { nome: 'Passos', uf: 'MG', populacao: 111998, regiao: 'Sudeste', isCapital: false, lat: -20.7189, lng: -46.6097 },
  { nome: 'Barbacena', uf: 'MG', populacao: 125317, regiao: 'Sudeste', isCapital: false, lat: -21.2258, lng: -43.7736 },
  { nome: 'Nova Lima', uf: 'MG', populacao: 111697, regiao: 'Sudeste', isCapital: false, lat: -19.9858, lng: -43.8469 },
  { nome: 'Lavras', uf: 'MG', populacao: 104761, regiao: 'Sudeste', isCapital: false, lat: -21.2464, lng: -45.0014 },
  { nome: 'Itabira', uf: 'MG', populacao: 113343, regiao: 'Sudeste', isCapital: false, lat: -19.6189, lng: -43.2269 },
  { nome: 'Coronel Fabriciano', uf: 'MG', populacao: 104736, regiao: 'Sudeste', isCapital: false, lat: -19.5189, lng: -42.6289 },
  { nome: 'Muriaé', uf: 'MG', populacao: 104166, regiao: 'Sudeste', isCapital: false, lat: -21.1306, lng: -42.3664 },
  { nome: 'Ubá', uf: 'MG', populacao: 103365, regiao: 'Sudeste', isCapital: false, lat: -21.1203, lng: -42.9428 },
  { nome: 'Itajubá', uf: 'MG', populacao: 93073, regiao: 'Sudeste', isCapital: false, lat: -22.4261, lng: -45.4528 },
  { nome: 'Itaúna', uf: 'MG', populacao: 97669, regiao: 'Sudeste', isCapital: false, lat: -20.0758, lng: -44.5764 },
  { nome: 'Paracatu', uf: 'MG', populacao: 94017, regiao: 'Sudeste', isCapital: false, lat: -17.2222, lng: -46.8747 },
  { nome: 'Caratinga', uf: 'MG', populacao: 87360, regiao: 'Sudeste', isCapital: false, lat: -19.7917, lng: -42.1383 },
  { nome: 'São João del-Rei', uf: 'MG', populacao: 90082, regiao: 'Sudeste', isCapital: false, lat: -21.1356, lng: -44.2617 },
  { nome: 'Patrocínio', uf: 'MG', populacao: 89826, regiao: 'Sudeste', isCapital: false, lat: -18.9439, lng: -46.9928 },
  { nome: 'Alfenas', uf: 'MG', populacao: 80000, regiao: 'Sudeste', isCapital: false, lat: -21.4258, lng: -45.9469 },
  { nome: 'Unaí', uf: 'MG', populacao: 86619, regiao: 'Sudeste', isCapital: false, lat: -16.3578, lng: -46.9056 },
  { nome: 'Manhuaçu', uf: 'MG', populacao: 89679, regiao: 'Sudeste', isCapital: false, lat: -20.2581, lng: -42.0336 },
  { nome: 'Timóteo', uf: 'MG', populacao: 81579, regiao: 'Sudeste', isCapital: false, lat: -19.5828, lng: -42.6439 },

  // ==================== SUDESTE - RIO DE JANEIRO ====================
  { nome: 'Rio de Janeiro', uf: 'RJ', populacao: 6211423, regiao: 'Sudeste', isCapital: true, lat: -22.9068, lng: -43.1729 },
  { nome: 'São Gonçalo', uf: 'RJ', populacao: 896744, regiao: 'Sudeste', isCapital: false, lat: -22.8269, lng: -43.0539 },
  { nome: 'Duque de Caxias', uf: 'RJ', populacao: 808152, regiao: 'Sudeste', isCapital: false, lat: -22.7858, lng: -43.3117 },
  { nome: 'Nova Iguaçu', uf: 'RJ', populacao: 785867, regiao: 'Sudeste', isCapital: false, lat: -22.7558, lng: -43.4603 },
  { nome: 'Niterói', uf: 'RJ', populacao: 481758, regiao: 'Sudeste', isCapital: false, lat: -22.8833, lng: -43.1036 },
  { nome: 'Belford Roxo', uf: 'RJ', populacao: 483087, regiao: 'Sudeste', isCapital: false, lat: -22.7642, lng: -43.3997 },
  { nome: 'Campos dos Goytacazes', uf: 'RJ', populacao: 483551, regiao: 'Sudeste', isCapital: false, lat: -21.7547, lng: -41.3244 },
  { nome: 'São João de Meriti', uf: 'RJ', populacao: 440962, regiao: 'Sudeste', isCapital: false, lat: -22.8042, lng: -43.3725 },
  { nome: 'Petrópolis', uf: 'RJ', populacao: 278881, regiao: 'Sudeste', isCapital: false, lat: -22.5050, lng: -43.1789 },
  { nome: 'Volta Redonda', uf: 'RJ', populacao: 261584, regiao: 'Sudeste', isCapital: false, lat: -22.5231, lng: -44.1042 },
  { nome: 'Macaé', uf: 'RJ', populacao: 246391, regiao: 'Sudeste', isCapital: false, lat: -22.3769, lng: -41.7869 },
  { nome: 'Magé', uf: 'RJ', populacao: 228127, regiao: 'Sudeste', isCapital: false, lat: -22.6528, lng: -43.0406 },
  { nome: 'Itaboraí', uf: 'RJ', populacao: 224267, regiao: 'Sudeste', isCapital: false, lat: -22.7444, lng: -42.8597 },
  { nome: 'Cabo Frio', uf: 'RJ', populacao: 221987, regiao: 'Sudeste', isCapital: false, lat: -22.8794, lng: -42.0186 },
  { nome: 'Angra dos Reis', uf: 'RJ', populacao: 167418, regiao: 'Sudeste', isCapital: false, lat: -23.0067, lng: -44.3181 },
  { nome: 'Nova Friburgo', uf: 'RJ', populacao: 189937, regiao: 'Sudeste', isCapital: false, lat: -22.2819, lng: -42.5311 },
  { nome: 'Barra Mansa', uf: 'RJ', populacao: 169899, regiao: 'Sudeste', isCapital: false, lat: -22.5442, lng: -44.1714 },
  { nome: 'Teresópolis', uf: 'RJ', populacao: 165123, regiao: 'Sudeste', isCapital: false, lat: -22.4122, lng: -42.9664 },
  { nome: 'Mesquita', uf: 'RJ', populacao: 167127, regiao: 'Sudeste', isCapital: false, lat: -22.7828, lng: -43.4286 },
  { nome: 'Nilópolis', uf: 'RJ', populacao: 146774, regiao: 'Sudeste', isCapital: false, lat: -22.8089, lng: -43.4136 },
  { nome: 'Maricá', uf: 'RJ', populacao: 197300, regiao: 'Sudeste', isCapital: false, lat: -22.9194, lng: -42.8186 },
  { nome: 'Rio das Ostras', uf: 'RJ', populacao: 156491, regiao: 'Sudeste', isCapital: false, lat: -22.5269, lng: -41.9458 },
  { nome: 'Resende', uf: 'RJ', populacao: 129612, regiao: 'Sudeste', isCapital: false, lat: -22.4689, lng: -44.4467 },
  { nome: 'Araruama', uf: 'RJ', populacao: 129333, regiao: 'Sudeste', isCapital: false, lat: -22.8728, lng: -42.3431 },
  { nome: 'Itaperuna', uf: 'RJ', populacao: 101041, regiao: 'Sudeste', isCapital: false, lat: -21.2056, lng: -41.8875 },

  // ==================== SUDESTE - ESPÍRITO SANTO ====================
  { nome: 'Vitória', uf: 'ES', populacao: 322869, regiao: 'Sudeste', isCapital: true, lat: -20.3155, lng: -40.3128 },
  { nome: 'Serra', uf: 'ES', populacao: 520653, regiao: 'Sudeste', isCapital: false, lat: -20.1286, lng: -40.3078 },
  { nome: 'Vila Velha', uf: 'ES', populacao: 467722, regiao: 'Sudeste', isCapital: false, lat: -20.3297, lng: -40.2925 },
  { nome: 'Cariacica', uf: 'ES', populacao: 353510, regiao: 'Sudeste', isCapital: false, lat: -20.2639, lng: -40.4200 },
  { nome: 'Cachoeiro de Itapemirim', uf: 'ES', populacao: 185784, regiao: 'Sudeste', isCapital: false, lat: -20.8489, lng: -41.1128 },
  { nome: 'Linhares', uf: 'ES', populacao: 171606, regiao: 'Sudeste', isCapital: false, lat: -19.3911, lng: -40.0722 },
  { nome: 'São Mateus', uf: 'ES', populacao: 123750, regiao: 'Sudeste', isCapital: false, lat: -18.7161, lng: -39.8589 },
  { nome: 'Colatina', uf: 'ES', populacao: 119938, regiao: 'Sudeste', isCapital: false, lat: -19.5392, lng: -40.6306 },
  { nome: 'Guarapari', uf: 'ES', populacao: 124656, regiao: 'Sudeste', isCapital: false, lat: -20.6667, lng: -40.4975 },
  { nome: 'Aracruz', uf: 'ES', populacao: 94765, regiao: 'Sudeste', isCapital: false, lat: -19.8203, lng: -40.2733 },

  // ==================== SUL - PARANÁ ====================
  { nome: 'Curitiba', uf: 'PR', populacao: 1773733, regiao: 'Sul', isCapital: true, lat: -25.4284, lng: -49.2733 },
  { nome: 'Londrina', uf: 'PR', populacao: 555965, regiao: 'Sul', isCapital: false, lat: -23.3045, lng: -51.1696 },
  { nome: 'Maringá', uf: 'PR', populacao: 409657, regiao: 'Sul', isCapital: false, lat: -23.4209, lng: -51.9331 },
  { nome: 'Ponta Grossa', uf: 'PR', populacao: 358371, regiao: 'Sul', isCapital: false, lat: -25.0950, lng: -50.1619 },
  { nome: 'Cascavel', uf: 'PR', populacao: 348051, regiao: 'Sul', isCapital: false, lat: -24.9578, lng: -53.4594 },
  { nome: 'São José dos Pinhais', uf: 'PR', populacao: 329222, regiao: 'Sul', isCapital: false, lat: -25.5347, lng: -49.2064 },
  { nome: 'Foz do Iguaçu', uf: 'PR', populacao: 285415, regiao: 'Sul', isCapital: false, lat: -25.5163, lng: -54.5854 },
  { nome: 'Colombo', uf: 'PR', populacao: 232056, regiao: 'Sul', isCapital: false, lat: -25.2917, lng: -49.2242 },
  { nome: 'Guarapuava', uf: 'PR', populacao: 182644, regiao: 'Sul', isCapital: false, lat: -25.3953, lng: -51.4625 },
  { nome: 'Araucária', uf: 'PR', populacao: 151666, regiao: 'Sul', isCapital: false, lat: -25.5928, lng: -49.3347 },
  { nome: 'Toledo', uf: 'PR', populacao: 150470, regiao: 'Sul', isCapital: false, lat: -24.7139, lng: -53.7431 },
  { nome: 'Paranaguá', uf: 'PR', populacao: 145829, regiao: 'Sul', isCapital: false, lat: -25.5206, lng: -48.5092 },
  { nome: 'Campo Largo', uf: 'PR', populacao: 136327, regiao: 'Sul', isCapital: false, lat: -25.4594, lng: -49.5264 },
  { nome: 'Apucarana', uf: 'PR', populacao: 130134, regiao: 'Sul', isCapital: false, lat: -23.5514, lng: -51.4614 },
  { nome: 'Pinhais', uf: 'PR', populacao: 127019, regiao: 'Sul', isCapital: false, lat: -25.4339, lng: -49.1914 },
  { nome: 'Arapongas', uf: 'PR', populacao: 119138, regiao: 'Sul', isCapital: false, lat: -23.4189, lng: -51.4239 },
  { nome: 'Almirante Tamandaré', uf: 'PR', populacao: 119825, regiao: 'Sul', isCapital: false, lat: -25.3219, lng: -49.3089 },
  { nome: 'Piraquara', uf: 'PR', populacao: 118730, regiao: 'Sul', isCapital: false, lat: -25.4419, lng: -49.0631 },
  { nome: 'Umuarama', uf: 'PR', populacao: 117072, regiao: 'Sul', isCapital: false, lat: -23.7664, lng: -53.3250 },
  { nome: 'Cambé', uf: 'PR', populacao: 107208, regiao: 'Sul', isCapital: false, lat: -23.2758, lng: -51.2789 },
  { nome: 'Fazenda Rio Grande', uf: 'PR', populacao: 148873, regiao: 'Sul', isCapital: false, lat: -25.6589, lng: -49.3089 },
  { nome: 'Campo Mourão', uf: 'PR', populacao: 99458, regiao: 'Sul', isCapital: false, lat: -24.0458, lng: -52.3789 },

  // ==================== SUL - SANTA CATARINA ====================
  { nome: 'Florianópolis', uf: 'SC', populacao: 537213, regiao: 'Sul', isCapital: true, lat: -27.5954, lng: -48.5480 },
  { nome: 'Joinville', uf: 'SC', populacao: 616323, regiao: 'Sul', isCapital: false, lat: -26.3045, lng: -48.8487 },
  { nome: 'Blumenau', uf: 'SC', populacao: 361261, regiao: 'Sul', isCapital: false, lat: -26.9194, lng: -49.0661 },
  { nome: 'São José', uf: 'SC', populacao: 270295, regiao: 'Sul', isCapital: false, lat: -27.6136, lng: -48.6367 },
  { nome: 'Itajaí', uf: 'SC', populacao: 264054, regiao: 'Sul', isCapital: false, lat: -26.9078, lng: -48.6619 },
  { nome: 'Chapecó', uf: 'SC', populacao: 254781, regiao: 'Sul', isCapital: false, lat: -27.1006, lng: -52.6153 },
  { nome: 'Palhoça', uf: 'SC', populacao: 222598, regiao: 'Sul', isCapital: false, lat: -27.6456, lng: -48.6681 },
  { nome: 'Criciúma', uf: 'SC', populacao: 214493, regiao: 'Sul', isCapital: false, lat: -28.6775, lng: -49.3703 },
  { nome: 'Jaraguá do Sul', uf: 'SC', populacao: 182636, regiao: 'Sul', isCapital: false, lat: -26.4850, lng: -49.0700 },
  { nome: 'Lages', uf: 'SC', populacao: 164981, regiao: 'Sul', isCapital: false, lat: -27.8158, lng: -50.3261 },
  { nome: 'Brusque', uf: 'SC', populacao: 141385, regiao: 'Sul', isCapital: false, lat: -27.0989, lng: -48.9169 },
  { nome: 'Balneário Camboriú', uf: 'SC', populacao: 139155, regiao: 'Sul', isCapital: false, lat: -26.9928, lng: -48.6353 },
  { nome: 'Tubarão', uf: 'SC', populacao: 110088, regiao: 'Sul', isCapital: false, lat: -28.4800, lng: -49.0069 },
  { nome: 'São Bento do Sul', uf: 'SC', populacao: 86317, regiao: 'Sul', isCapital: false, lat: -26.2503, lng: -49.3800 },
  { nome: 'Camboriú', uf: 'SC', populacao: 103074, regiao: 'Sul', isCapital: false, lat: -27.0258, lng: -48.6558 },
  { nome: 'Navegantes', uf: 'SC', populacao: 86401, regiao: 'Sul', isCapital: false, lat: -26.8964, lng: -48.6542 },

  // ==================== SUL - RIO GRANDE DO SUL ====================
  { nome: 'Porto Alegre', uf: 'RS', populacao: 1332570, regiao: 'Sul', isCapital: true, lat: -30.0346, lng: -51.2177 },
  { nome: 'Caxias do Sul', uf: 'RS', populacao: 463377, regiao: 'Sul', isCapital: false, lat: -29.1678, lng: -51.1794 },
  { nome: 'Canoas', uf: 'RS', populacao: 347657, regiao: 'Sul', isCapital: false, lat: -29.9178, lng: -51.1839 },
  { nome: 'Pelotas', uf: 'RS', populacao: 325689, regiao: 'Sul', isCapital: false, lat: -31.7654, lng: -52.3376 },
  { nome: 'Santa Maria', uf: 'RS', populacao: 271633, regiao: 'Sul', isCapital: false, lat: -29.6842, lng: -53.8069 },
  { nome: 'Gravataí', uf: 'RS', populacao: 265070, regiao: 'Sul', isCapital: false, lat: -29.9439, lng: -50.9928 },
  { nome: 'Viamão', uf: 'RS', populacao: 224116, regiao: 'Sul', isCapital: false, lat: -30.0811, lng: -51.0233 },
  { nome: 'Novo Hamburgo', uf: 'RS', populacao: 227732, regiao: 'Sul', isCapital: false, lat: -29.6789, lng: -51.1308 },
  { nome: 'São Leopoldo', uf: 'RS', populacao: 217410, regiao: 'Sul', isCapital: false, lat: -29.7600, lng: -51.1472 },
  { nome: 'Rio Grande', uf: 'RS', populacao: 191900, regiao: 'Sul', isCapital: false, lat: -32.0350, lng: -52.0986 },
  { nome: 'Alvorada', uf: 'RS', populacao: 187315, regiao: 'Sul', isCapital: false, lat: -30.0039, lng: -51.0828 },
  { nome: 'Passo Fundo', uf: 'RS', populacao: 206224, regiao: 'Sul', isCapital: false, lat: -28.2611, lng: -52.4083 },
  { nome: 'Sapucaia do Sul', uf: 'RS', populacao: 132107, regiao: 'Sul', isCapital: false, lat: -29.8378, lng: -51.1458 },
  { nome: 'Santa Cruz do Sul', uf: 'RS', populacao: 133230, regiao: 'Sul', isCapital: false, lat: -29.7189, lng: -52.4286 },
  { nome: 'Uruguaiana', uf: 'RS', populacao: 117210, regiao: 'Sul', isCapital: false, lat: -29.7547, lng: -57.0853 },
  { nome: 'Bento Gonçalves', uf: 'RS', populacao: 123151, regiao: 'Sul', isCapital: false, lat: -29.1717, lng: -51.5189 },
  { nome: 'Bagé', uf: 'RS', populacao: 117938, regiao: 'Sul', isCapital: false, lat: -31.3314, lng: -54.1069 },
  { nome: 'Erechim', uf: 'RS', populacao: 105705, regiao: 'Sul', isCapital: false, lat: -27.6339, lng: -52.2689 },
  { nome: 'Guaíba', uf: 'RS', populacao: 92924, regiao: 'Sul', isCapital: false, lat: -30.1139, lng: -51.3250 },
  { nome: 'Cachoeirinha', uf: 'RS', populacao: 136229, regiao: 'Sul', isCapital: false, lat: -29.9508, lng: -51.0942 },

  // ==================== CENTRO-OESTE ====================
  { nome: 'Brasília', uf: 'DF', populacao: 2817068, regiao: 'Centro-Oeste', isCapital: true, lat: -15.7975, lng: -47.8919 },
  { nome: 'Goiânia', uf: 'GO', populacao: 1437237, regiao: 'Centro-Oeste', isCapital: true, lat: -16.6869, lng: -49.2648 },
  { nome: 'Aparecida de Goiânia', uf: 'GO', populacao: 527550, regiao: 'Centro-Oeste', isCapital: false, lat: -16.8228, lng: -49.2481 },
  { nome: 'Anápolis', uf: 'GO', populacao: 398817, regiao: 'Centro-Oeste', isCapital: false, lat: -16.3267, lng: -48.9533 },
  { nome: 'Rio Verde', uf: 'GO', populacao: 225696, regiao: 'Centro-Oeste', isCapital: false, lat: -17.7928, lng: -50.9192 },
  { nome: 'Luziânia', uf: 'GO', populacao: 208725, regiao: 'Centro-Oeste', isCapital: false, lat: -16.2525, lng: -47.9500 },
  { nome: 'Águas Lindas de Goiás', uf: 'GO', populacao: 225671, regiao: 'Centro-Oeste', isCapital: false, lat: -15.7622, lng: -48.2819 },
  { nome: 'Valparaíso de Goiás', uf: 'GO', populacao: 198861, regiao: 'Centro-Oeste', isCapital: false, lat: -16.0689, lng: -47.9758 },
  { nome: 'Trindade', uf: 'GO', populacao: 142435, regiao: 'Centro-Oeste', isCapital: false, lat: -16.6489, lng: -49.4914 },
  { nome: 'Formosa', uf: 'GO', populacao: 115669, regiao: 'Centro-Oeste', isCapital: false, lat: -15.5369, lng: -47.3364 },
  { nome: 'Senador Canedo', uf: 'GO', populacao: 155635, regiao: 'Centro-Oeste', isCapital: false, lat: -16.7089, lng: -49.0914 },
  { nome: 'Itumbiara', uf: 'GO', populacao: 107970, regiao: 'Centro-Oeste', isCapital: false, lat: -18.4194, lng: -49.2178 },
  { nome: 'Catalão', uf: 'GO', populacao: 110983, regiao: 'Centro-Oeste', isCapital: false, lat: -18.1658, lng: -47.9464 },
  { nome: 'Jataí', uf: 'GO', populacao: 105729, regiao: 'Centro-Oeste', isCapital: false, lat: -17.8814, lng: -51.7144 },

  { nome: 'Cuiabá', uf: 'MT', populacao: 650912, regiao: 'Centro-Oeste', isCapital: true, lat: -15.6014, lng: -56.0979 },
  { nome: 'Várzea Grande', uf: 'MT', populacao: 299472, regiao: 'Centro-Oeste', isCapital: false, lat: -15.6464, lng: -56.1325 },
  { nome: 'Rondonópolis', uf: 'MT', populacao: 244897, regiao: 'Centro-Oeste', isCapital: false, lat: -16.4675, lng: -54.6372 },
  { nome: 'Sinop', uf: 'MT', populacao: 196094, regiao: 'Centro-Oeste', isCapital: false, lat: -11.8608, lng: -55.5097 },
  { nome: 'Tangará da Serra', uf: 'MT', populacao: 106434, regiao: 'Centro-Oeste', isCapital: false, lat: -14.6225, lng: -57.4914 },
  { nome: 'Sorriso', uf: 'MT', populacao: 110603, regiao: 'Centro-Oeste', isCapital: false, lat: -12.5425, lng: -55.7114 },
  { nome: 'Lucas do Rio Verde', uf: 'MT', populacao: 83798, regiao: 'Centro-Oeste', isCapital: false, lat: -13.0500, lng: -55.9100 },

  { nome: 'Campo Grande', uf: 'MS', populacao: 897938, regiao: 'Centro-Oeste', isCapital: true, lat: -20.4697, lng: -54.6201 },
  { nome: 'Dourados', uf: 'MS', populacao: 243367, regiao: 'Centro-Oeste', isCapital: false, lat: -22.2211, lng: -54.8056 },
  { nome: 'Três Lagoas', uf: 'MS', populacao: 132152, regiao: 'Centro-Oeste', isCapital: false, lat: -20.7850, lng: -51.7050 },
  { nome: 'Corumbá', uf: 'MS', populacao: 96261, regiao: 'Centro-Oeste', isCapital: false, lat: -19.0097, lng: -57.6533 },
  { nome: 'Ponta Porã', uf: 'MS', populacao: 92017, regiao: 'Centro-Oeste', isCapital: false, lat: -22.5361, lng: -55.7256 },

  // ==================== NORDESTE ====================
  { nome: 'Salvador', uf: 'BA', populacao: 2418005, regiao: 'Nordeste', isCapital: true, lat: -12.9777, lng: -38.5016 },
  { nome: 'Feira de Santana', uf: 'BA', populacao: 616279, regiao: 'Nordeste', isCapital: false, lat: -12.2664, lng: -38.9664 },
  { nome: 'Vitória da Conquista', uf: 'BA', populacao: 370868, regiao: 'Nordeste', isCapital: false, lat: -14.8661, lng: -40.8394 },
  { nome: 'Camaçari', uf: 'BA', populacao: 299558, regiao: 'Nordeste', isCapital: false, lat: -12.6975, lng: -38.3242 },
  { nome: 'Juazeiro', uf: 'BA', populacao: 235816, regiao: 'Nordeste', isCapital: false, lat: -9.4167, lng: -40.5033 },
  { nome: 'Itabuna', uf: 'BA', populacao: 186708, regiao: 'Nordeste', isCapital: false, lat: -14.7875, lng: -39.2789 },
  { nome: 'Lauro de Freitas', uf: 'BA', populacao: 203334, regiao: 'Nordeste', isCapital: false, lat: -12.8944, lng: -38.3272 },
  { nome: 'Ilhéus', uf: 'BA', populacao: 178703, regiao: 'Nordeste', isCapital: false, lat: -14.7889, lng: -39.0494 },
  { nome: 'Jequié', uf: 'BA', populacao: 158812, regiao: 'Nordeste', isCapital: false, lat: -13.8581, lng: -40.0842 },
  { nome: 'Teixeira de Freitas', uf: 'BA', populacao: 145223, regiao: 'Nordeste', isCapital: false, lat: -17.5358, lng: -39.7422 },
  { nome: 'Barreiras', uf: 'BA', populacao: 159743, regiao: 'Nordeste', isCapital: false, lat: -12.1528, lng: -44.9961 },
  { nome: 'Alagoinhas', uf: 'BA', populacao: 151065, regiao: 'Nordeste', isCapital: false, lat: -12.1356, lng: -38.4192 },
  { nome: 'Porto Seguro', uf: 'BA', populacao: 167955, regiao: 'Nordeste', isCapital: false, lat: -16.4497, lng: -39.0647 },
  { nome: 'Simões Filho', uf: 'BA', populacao: 114441, regiao: 'Nordeste', isCapital: false, lat: -12.7878, lng: -38.4028 },
  { nome: 'Paulo Afonso', uf: 'BA', populacao: 112870, regiao: 'Nordeste', isCapital: false, lat: -9.4000, lng: -38.2167 },

  { nome: 'Fortaleza', uf: 'CE', populacao: 2428678, regiao: 'Nordeste', isCapital: true, lat: -3.7319, lng: -38.5267 },
  { nome: 'Caucaia', uf: 'CE', populacao: 355679, regiao: 'Nordeste', isCapital: false, lat: -3.7361, lng: -38.6531 },
  { nome: 'Juazeiro do Norte', uf: 'CE', populacao: 286120, regiao: 'Nordeste', isCapital: false, lat: -7.2131, lng: -39.3153 },
  { nome: 'Maracanaú', uf: 'CE', populacao: 234392, regiao: 'Nordeste', isCapital: false, lat: -3.8767, lng: -38.6256 },
  { nome: 'Sobral', uf: 'CE', populacao: 203062, regiao: 'Nordeste', isCapital: false, lat: -3.6894, lng: -40.3481 },
  { nome: 'Crato', uf: 'CE', populacao: 131050, regiao: 'Nordeste', isCapital: false, lat: -7.2344, lng: -39.4094 },
  { nome: 'Itapipoca', uf: 'CE', populacao: 131123, regiao: 'Nordeste', isCapital: false, lat: -3.4944, lng: -39.5786 },
  { nome: 'Maranguape', uf: 'CE', populacao: 138920, regiao: 'Nordeste', isCapital: false, lat: -3.8889, lng: -38.6833 },
  { nome: 'Iguatu', uf: 'CE', populacao: 98064, regiao: 'Nordeste', isCapital: false, lat: -6.3589, lng: -39.2989 },

  { nome: 'Recife', uf: 'PE', populacao: 1488920, regiao: 'Nordeste', isCapital: true, lat: -8.0476, lng: -34.8770 },
  { nome: 'Jaboatão dos Guararapes', uf: 'PE', populacao: 643759, regiao: 'Nordeste', isCapital: false, lat: -8.1128, lng: -35.0150 },
  { nome: 'Olinda', uf: 'PE', populacao: 349976, regiao: 'Nordeste', isCapital: false, lat: -7.9986, lng: -34.8458 },
  { nome: 'Caruaru', uf: 'PE', populacao: 378052, regiao: 'Nordeste', isCapital: false, lat: -8.2839, lng: -35.9761 },
  { nome: 'Petrolina', uf: 'PE', populacao: 386786, regiao: 'Nordeste', isCapital: false, lat: -9.3889, lng: -40.5008 },
  { nome: 'Paulista', uf: 'PE', populacao: 342167, regiao: 'Nordeste', isCapital: false, lat: -7.9408, lng: -34.8728 },
  { nome: 'Cabo de Santo Agostinho', uf: 'PE', populacao: 203216, regiao: 'Nordeste', isCapital: false, lat: -8.2814, lng: -35.0347 },
  { nome: 'Camaragibe', uf: 'PE', populacao: 147771, regiao: 'Nordeste', isCapital: false, lat: -8.0208, lng: -34.9819 },
  { nome: 'Garanhuns', uf: 'PE', populacao: 142506, regiao: 'Nordeste', isCapital: false, lat: -8.8903, lng: -36.4928 },
  { nome: 'Vitória de Santo Antão', uf: 'PE', populacao: 134141, regiao: 'Nordeste', isCapital: false, lat: -8.1189, lng: -35.2928 },
  { nome: 'Igarassu', uf: 'PE', populacao: 115196, regiao: 'Nordeste', isCapital: false, lat: -7.8342, lng: -34.9064 },
  { nome: 'São Lourenço da Mata', uf: 'PE', populacao: 111249, regiao: 'Nordeste', isCapital: false, lat: -8.0028, lng: -35.0189 },

  { nome: 'São Luís', uf: 'MA', populacao: 1037775, regiao: 'Nordeste', isCapital: true, lat: -2.5307, lng: -44.3068 },
  { nome: 'Imperatriz', uf: 'MA', populacao: 273110, regiao: 'Nordeste', isCapital: false, lat: -5.5264, lng: -47.4778 },
  { nome: 'São José de Ribamar', uf: 'MA', populacao: 244579, regiao: 'Nordeste', isCapital: false, lat: -2.5622, lng: -44.0539 },
  { nome: 'Timon', uf: 'MA', populacao: 174465, regiao: 'Nordeste', isCapital: false, lat: -5.0939, lng: -42.8364 },
  { nome: 'Caxias', uf: 'MA', populacao: 156973, regiao: 'Nordeste', isCapital: false, lat: -4.8589, lng: -43.3558 },
  { nome: 'Paço do Lumiar', uf: 'MA', populacao: 145643, regiao: 'Nordeste', isCapital: false, lat: -2.5317, lng: -44.1081 },

  { nome: 'Natal', uf: 'RN', populacao: 751300, regiao: 'Nordeste', isCapital: true, lat: -5.7945, lng: -35.2110 },
  { nome: 'Mossoró', uf: 'RN', populacao: 264577, regiao: 'Nordeste', isCapital: false, lat: -5.1878, lng: -37.3442 },
  { nome: 'Parnamirim', uf: 'RN', populacao: 252716, regiao: 'Nordeste', isCapital: false, lat: -5.9156, lng: -35.2628 },
  { nome: 'São Gonçalo do Amarante', uf: 'RN', populacao: 115838, regiao: 'Nordeste', isCapital: false, lat: -5.7928, lng: -35.3289 },

  { nome: 'João Pessoa', uf: 'PB', populacao: 833932, regiao: 'Nordeste', isCapital: true, lat: -7.1153, lng: -34.8610 },
  { nome: 'Campina Grande', uf: 'PB', populacao: 419379, regiao: 'Nordeste', isCapital: false, lat: -7.2219, lng: -35.8828 },
  { nome: 'Santa Rita', uf: 'PB', populacao: 149910, regiao: 'Nordeste', isCapital: false, lat: -7.1139, lng: -34.9781 },
  { nome: 'Patos', uf: 'PB', populacao: 103165, regiao: 'Nordeste', isCapital: false, lat: -7.0244, lng: -37.2800 },

  { nome: 'Maceió', uf: 'AL', populacao: 957916, regiao: 'Nordeste', isCapital: true, lat: -9.6658, lng: -35.7353 },
  { nome: 'Arapiraca', uf: 'AL', populacao: 234696, regiao: 'Nordeste', isCapital: false, lat: -9.7522, lng: -36.6606 },
  { nome: 'Rio Largo', uf: 'AL', populacao: 93927, regiao: 'Nordeste', isCapital: false, lat: -9.4772, lng: -35.8528 },

  { nome: 'Teresina', uf: 'PI', populacao: 866300, regiao: 'Nordeste', isCapital: true, lat: -5.0919, lng: -42.8034 },
  { nome: 'Parnaíba', uf: 'PI', populacao: 162159, regiao: 'Nordeste', isCapital: false, lat: -2.9039, lng: -41.7769 },

  { nome: 'Aracaju', uf: 'SE', populacao: 602757, regiao: 'Nordeste', isCapital: true, lat: -10.9111, lng: -37.0717 },
  { nome: 'Nossa Senhora do Socorro', uf: 'SE', populacao: 192330, regiao: 'Nordeste', isCapital: false, lat: -10.8547, lng: -37.1264 },
  { nome: 'Lagarto', uf: 'SE', populacao: 101579, regiao: 'Nordeste', isCapital: false, lat: -10.9169, lng: -37.6500 },
  { nome: 'Itabaiana', uf: 'SE', populacao: 103440, regiao: 'Nordeste', isCapital: false, lat: -10.6850, lng: -37.4253 },

  // ==================== NORTE ====================
  { nome: 'Manaus', uf: 'AM', populacao: 2063547, regiao: 'Norte', isCapital: true, lat: -3.1190, lng: -60.0217 },
  { nome: 'Parintins', uf: 'AM', populacao: 96372, regiao: 'Norte', isCapital: false, lat: -2.6289, lng: -56.7358 },
  { nome: 'Itacoatiara', uf: 'AM', populacao: 103598, regiao: 'Norte', isCapital: false, lat: -3.1431, lng: -58.4442 },

  { nome: 'Belém', uf: 'PA', populacao: 1303389, regiao: 'Norte', isCapital: true, lat: -1.4558, lng: -48.4902 },
  { nome: 'Ananindeua', uf: 'PA', populacao: 478778, regiao: 'Norte', isCapital: false, lat: -1.3656, lng: -48.3722 },
  { nome: 'Santarém', uf: 'PA', populacao: 331937, regiao: 'Norte', isCapital: false, lat: -2.4431, lng: -54.7083 },
  { nome: 'Marabá', uf: 'PA', populacao: 266536, regiao: 'Norte', isCapital: false, lat: -5.3686, lng: -49.1178 },
  { nome: 'Parauapebas', uf: 'PA', populacao: 266424, regiao: 'Norte', isCapital: false, lat: -6.0678, lng: -49.9022 },
  { nome: 'Castanhal', uf: 'PA', populacao: 192262, regiao: 'Norte', isCapital: false, lat: -1.2967, lng: -47.9258 },
  { nome: 'Abaetetuba', uf: 'PA', populacao: 158188, regiao: 'Norte', isCapital: false, lat: -1.7219, lng: -48.8831 },
  { nome: 'Cametá', uf: 'PA', populacao: 134172, regiao: 'Norte', isCapital: false, lat: -2.2417, lng: -49.4958 },
  { nome: 'Marituba', uf: 'PA', populacao: 111785, regiao: 'Norte', isCapital: false, lat: -1.3556, lng: -48.3414 },

  { nome: 'Porto Velho', uf: 'RO', populacao: 460413, regiao: 'Norte', isCapital: true, lat: -8.7619, lng: -63.9039 },
  { nome: 'Ji-Paraná', uf: 'RO', populacao: 124333, regiao: 'Norte', isCapital: false, lat: -10.8842, lng: -61.9514 },
  { nome: 'Ariquemes', uf: 'RO', populacao: 96833, regiao: 'Norte', isCapital: false, lat: -9.9133, lng: -63.0408 },

  { nome: 'Macapá', uf: 'AP', populacao: 442933, regiao: 'Norte', isCapital: true, lat: 0.0389, lng: -51.0664 },
  { nome: 'Santana', uf: 'AP', populacao: 107618, regiao: 'Norte', isCapital: false, lat: -0.0583, lng: -51.1817 },

  { nome: 'Rio Branco', uf: 'AC', populacao: 364756, regiao: 'Norte', isCapital: true, lat: -9.9753, lng: -67.8249 },
  { nome: 'Cruzeiro do Sul', uf: 'AC', populacao: 91888, regiao: 'Norte', isCapital: false, lat: -7.6311, lng: -72.6700 },

  { nome: 'Boa Vista', uf: 'RR', populacao: 413486, regiao: 'Norte', isCapital: true, lat: 2.8235, lng: -60.6758 },

  { nome: 'Palmas', uf: 'TO', populacao: 302692, regiao: 'Norte', isCapital: true, lat: -10.1844, lng: -48.3336 },
  { nome: 'Araguaína', uf: 'TO', populacao: 171301, regiao: 'Norte', isCapital: false, lat: -7.1903, lng: -48.2072 },
  { nome: 'Gurupi', uf: 'TO', populacao: 85126, regiao: 'Norte', isCapital: false, lat: -11.7297, lng: -49.0686 }
];

// Presets Prontos para Uso Estratégico Imediato
export const TERRITORY_PRESETS: TerritoryPreset[] = [
  // --- ESTRATÉGIA B2B: MÁXIMA CONVERSÃO (500 CIDADES EM 4 FASES) ---
  {
    id: 'b2b_500_all',
    nome: '🎯 Máxima Conversão B2B (500 Cidades Estratégicas)',
    descricao: 'Estratégia completa: 4 fases de expansão ordenada por liquidez, capital de giro e menor concorrência de agências.',
    icone: '🎯',
    badge: '500 Cidades • 4 Fases B2B',
    category: 'estrategico_b2b',
    cityList: getB2BCitiesList()
  },
  {
    id: 'b2b_fase1_agro',
    nome: '🌾 Fase 1: Polos de Riqueza & Agro (115 Cidades)',
    descricao: 'Interior do Brasil com altíssimo PIB agroindustrial, empresários com alto caixa e carência de agências digitais.',
    icone: '🌾',
    badge: 'Fase 1 • 115 Cidades',
    category: 'estrategico_b2b',
    cityList: getB2BCitiesList(1)
  },
  {
    id: 'b2b_fase2_polos',
    nome: '🥈 Fase 2: Grandes Polos Regionais (116 Cidades)',
    descricao: 'Centros de consumo consolidados, alto volume de prestação de serviços, comércio denso e faturamento expressivo.',
    icone: '🥈',
    badge: 'Fase 2 • 116 Cidades',
    category: 'estrategico_b2b',
    cityList: getB2BCitiesList(2)
  },
  {
    id: 'b2b_fase3_industria',
    nome: '🏭 Fase 3: Cinturões Industriais & Tecnologia (107 Cidades)',
    descricao: 'Cinturões industriais, clusters têxteis/calçadistas/metalúrgicos e grandes cidades-satélites de alta densidade.',
    icone: '🏭',
    badge: 'Fase 3 • 107 Cidades',
    category: 'estrategico_b2b',
    cityList: getB2BCitiesList(3)
  },
  {
    id: 'b2b_fase4_metropoles',
    nome: '💥 Fase 4: Metrópoles Globais & Expansão (162 Cidades)',
    descricao: 'São Paulo, Rio, Brasília, capitais globais e cidades de expansão secundária com demanda massiva.',
    icone: '💥',
    badge: 'Fase 4 • 162 Cidades',
    category: 'estrategico_b2b',
    cityList: getB2BCitiesList(4)
  },

  // --- CENSO DEMOGRÁFICO & RANKING POPULACIONAL (326 CIDADES) ---
  {
    id: 'brazil_all_326',
    nome: '🇧🇷 Brasil Completo (326 Cidades - Censo IBGE)',
    descricao: 'Todas as 326 principais cidades do país ordenadas estritamente por volume populacional e empresas.',
    icone: '🇧🇷',
    badge: '326 Cidades • 130M+ Pop',
    category: 'censo_nacional',
    cityFilter: () => true
  },
  {
    id: 'brazil_27_capitals',
    nome: '🏛️ Todas as 27 Capitais Brasileiras',
    descricao: 'São Paulo, Rio, Brasília, BH, Salvador, Curitiba, Fortaleza e todas as demais 21 capitais.',
    icone: '🏛️',
    badge: '27 Capitais • Brasil',
    category: 'censo_nacional',
    cityFilter: (c) => c.isCapital
  },
  {
    id: 'brazil_top_50',
    nome: '⚡ Top 50 Maiores Metrópoles (>500k hab)',
    descricao: 'As 50 maiores potências urbanas do Brasil com concentração máxima de empresas.',
    icone: '⚡',
    badge: 'Top 50 Metrópoles',
    category: 'censo_nacional',
    cityFilter: (c) => c.populacao >= 450000
  },
  {
    id: 'brazil_top_100',
    nome: '🌆 Top 100 Cidades Polo (>200k hab)',
    descricao: 'As 100 principais cidades brasileiras acima de 200 mil habitantes.',
    icone: '🌆',
    badge: 'Top 100 Cidades',
    category: 'censo_nacional',
    cityFilter: (c) => c.populacao >= 200000
  },

  // --- RECORTE REGIONAL & ESTADUAL ---
  {
    id: 'region_sudeste',
    nome: '🌴 Região Sudeste (SP, MG, RJ, ES)',
    descricao: '140+ cidades do polo mais industrializado e rico do Brasil.',
    icone: '🌴',
    badge: '140+ Cidades • Sudeste',
    category: 'regional',
    cityFilter: (c) => c.regiao === 'Sudeste'
  },
  {
    id: 'region_sul',
    nome: '🌾 Região Sul (PR, SC, RS)',
    descricao: '60+ cidades com alto poder aquisitivo nos estados do Paraná, Santa Catarina e Rio Grande do Sul.',
    icone: '🌾',
    badge: '60+ Cidades • Sul',
    category: 'regional',
    cityFilter: (c) => c.regiao === 'Sul'
  },
  {
    id: 'region_nordeste',
    nome: '☀️ Região Nordeste (BA, PE, CE, etc.)',
    descricao: 'Todas as capitais e cidades polo dos 9 estados nordestinos.',
    icone: '☀️',
    badge: '55+ Cidades • Nordeste',
    category: 'regional',
    cityFilter: (c) => c.regiao === 'Nordeste'
  },
  {
    id: 'region_centro_oeste',
    nome: '🚜 Centro-Oeste & Agro (GO, MT, MS, DF)',
    descricao: 'Brasília, Goiânia, Cuiabá, Campo Grande e polos do Agronegócio.',
    icone: '🚜',
    badge: '30 Cidades • Centro-Oeste',
    category: 'regional',
    cityFilter: (c) => c.regiao === 'Centro-Oeste'
  },
  {
    id: 'region_norte',
    nome: '🌳 Região Norte (AM, PA, RO, TO, etc.)',
    descricao: 'Manaus, Belém, Porto Velho, Palmas e polos amazônicos.',
    icone: '🌳',
    badge: '20 Cidades • Norte',
    category: 'regional',
    cityFilter: (c) => c.regiao === 'Norte'
  },
  {
    id: 'state_sp_top',
    nome: '🏙️ Estado de São Paulo (Top 70 Cidades)',
    descricao: 'Capital, ABC, Campinas, Baixada Santista, Vale do Paraíba e Interior Paulista.',
    icone: '🏙️',
    badge: '70 Cidades • SP',
    category: 'regional',
    cityFilter: (c) => c.uf === 'SP'
  },
  {
    id: 'state_mg_top',
    nome: '⛰️ Minas Gerais (Top 40 Cidades)',
    descricao: 'BH, Grande BH, Triângulo Mineiro, Zona da Mata e Sul de Minas.',
    icone: '⛰️',
    badge: '40 Cidades • MG',
    category: 'regional',
    cityFilter: (c) => c.uf === 'MG'
  },
  {
    id: 'state_rj_top',
    nome: '🏖️ Rio de Janeiro (Top 25 Cidades)',
    descricao: 'Capital, Baixada Fluminense, Niterói, Região dos Lagos e Médio Paraíba.',
    icone: '🏖️',
    badge: '25 Cidades • RJ',
    category: 'regional',
    cityFilter: (c) => c.uf === 'RJ'
  }
];

/**
 * Retorna as cidades ordenadas por população decrescente por padrão
 */
export function getSortedMasterCities(): MasterCity[] {
  return [...MASTER_BRAZIL_CITIES].sort((a, b) => b.populacao - a.populacao);
}

/**
 * Converte um Preset Territorial em uma lista pronta de regiões para a Campanha,
 * expandindo automaticamente os bairros das cidades que já possuem mapeamento curado!
 */
export function buildRegionsFromPreset(
  presetId: string, 
  autoExpandKnownNeighborhoods: boolean = true
): { id: string; name: string; cityName: string; lat: number; lng: number }[] {
  const preset = TERRITORY_PRESETS.find(p => p.id === presetId) || TERRITORY_PRESETS[0];
  
  // Se o preset tiver lista própria explícita (como as fases B2B), usa ela; senão filtra a lista mestre ordenada por população
  const matchedCities = preset.cityList 
    ? preset.cityList 
    : getSortedMasterCities().filter(preset.cityFilter || (() => true));
  
  const regions: { id: string; name: string; cityName: string; lat: number; lng: number }[] = [];

  matchedCities.forEach((city) => {
    const fullCityName = `${city.nome} - ${city.uf}`;
    
    // Se a cidade tiver bairros mapeados e o usuário optou por auto-expandir
    if (autoExpandKnownNeighborhoods) {
      const knownNhs = ibgeService.getKnownNeighborhoodsForCity(city.nome, city.uf);
      if (knownNhs && knownNhs.length > 0) {
        knownNhs.forEach((nh, idx) => {
          regions.push({
            id: `reg_${city.uf}_${city.nome.replace(/\s+/g, '_')}_${idx}_${nh.nome.replace(/\s+/g, '_')}`.toLowerCase(),
            name: nh.nome,
            cityName: fullCityName,
            lat: nh.lat || city.lat,
            lng: nh.lng || city.lng
          });
        });
        return;
      }
    }

    // Caso contrário ou se não tiver bairros detalhados, adiciona a cidade inteira
    regions.push({
      id: `city_${city.uf}_${city.nome.replace(/\s+/g, '_')}`.toLowerCase(),
      name: fullCityName,
      cityName: fullCityName,
      lat: city.lat,
      lng: city.lng
    });
  });

  return regions;
}
